import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

interface FolderState {
  openFolderIds: string[];
  openFolder: (folderId: string) => void;
  closeFolder: (folderId: string) => void;
  toggleFolder: (folderId: string) => void;
  isFolderOpen: (folderId: string) => boolean;
  closeAllFolders: () => void;
}

const useFolderStore = create<FolderState>()(
  devtools(
    persist(
      (set, get) => ({
        openFolderIds: [],

        openFolder: (folderId: string) =>
          set((state) => ({
            openFolderIds: [...new Set([...state.openFolderIds, folderId])],
          })),

        closeFolder: (folderId: string) =>
          set((state) => ({
            openFolderIds: state.openFolderIds.filter((id) => id !== folderId),
          })),

        toggleFolder: (folderId: string) => {
          const isFolderOpen = get().isFolderOpen(folderId);
          if (isFolderOpen) {
            get().closeFolder(folderId);
          } else {
            get().openFolder(folderId);
          }
        },

        isFolderOpen: (folderId: string) => {
          return get().openFolderIds.includes(folderId);
        },

        closeAllFolders: () => {
          set({ openFolderIds: [] });
        },
      }),
      {
        name: "folder-ui-storage",
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);

export default useFolderStore;
